'use client';

import { clsx } from '@libs/common-next';
import { Card, Heading, Picture, TextPassage } from '@petsmart-ui/sparky';

import type { PromoCardProps, PromoCardWrapperProps } from './types';

import './PromoCard.scss';

const PromoCardWrapper = function PromoCardWrapper({
    children,
    className,
    href,
    onClick,
    ...other
}: PromoCardWrapperProps) {
    const componentClassName = clsx('promo-card', !href && 'nolink', className);
    if (!href) {
        return (
            <div data-testid="promo-card" className={componentClassName} {...other}>
                {children}
            </div>
        );
    }

    return (
        <a data-testid="promo-card" onClick={onClick} href={href} className={componentClassName} {...other}>
            {children}
        </a>
    );
};

export default function PromoCard({
    children,
    className,
    description,
    header,
    imageItems,
    imgAlt,
    link,
    onClick,
    ...other
}: PromoCardProps) {
    return (
        <PromoCardWrapper href={link?.webUrl} className={className} onClick={onClick} {...other}>
            <Card tabIndex={0} variant="bare">
                <Card.Header>
                    <Picture
                        imgAlt={imgAlt}
                        imgSrc={imageItems[0]?.srcSet} // Sparky component expects fallback image
                        items={imageItems}
                        className="promo-card-image"
                    />
                </Card.Header>
                <Card.Body tabIndex={0}>
                    <Heading className="promo-card-header" tagName="h3" size="body-lg-bold">
                        {header}
                    </Heading>
                    {description && <TextPassage>{description}</TextPassage>}
                    {children}
                </Card.Body>
            </Card>
        </PromoCardWrapper>
    );
}
